import { defineComponent, onMounted, onUnmounted } from 'vue'
import deepcopy from 'deepcopy'
import { IContainerMenuitem } from '../../../json-parse/src/interface'
import { menuLayout } from '../../../json-parse/src/tools/register'
import UEI from '../use/useEditInfo'

export default defineComponent({
  name: 'JsonEditLeftMenu',
  setup() {
    let dragtarget: Element | null

    onMounted(() => {
      // 监听dragtarget的相关事件
      dragtarget = document.querySelector('.comp-menu')
      if(!dragtarget) return
      dragtarget.addEventListener('dragstart', dragStart)
      dragtarget.addEventListener('dragend', dragEnd)
    })

    onUnmounted(() => {
      if(!dragtarget) return
      dragtarget.removeEventListener('dragstart', dragStart)
      dragtarget.removeEventListener('dragend', dragEnd)
    })

    function dragStart(event: any) {
      const target = event.target
      target.style.opacity = 0.5
      target.style.background = 'rgb(243 247 255)'
      const index = event.target.getAttribute('data-dropedindex')
      const dropedInfo = menuLayout.compsList[index].dropedInfo
      // 计算偏移量
      const rectInfo = target.getBoundingClientRect()
      dropedInfo.xRelative = event.clientX - rectInfo.left
      dropedInfo.yRelative = event.clientY - rectInfo.top
      UEI.setDropedLayout(deepcopy(dropedInfo))
    }

    function dragEnd(event: any) {
      event.target.style.opacity = 1
      event.target.style.background = 'transparent'
      UEI.setDropedLayout(undefined)
    }

    return () => {
      return (
        <div class="comp-menu">
          {menuLayout.compsList.map((item: IContainerMenuitem, index:number) => {
            return (
              <div class="comp-menu-drag" data-dropedindex={index} draggable>
                <div class="comp-menu-drag-cover"></div>
                <div class="comp-menu-cover-text">{item.compLabel}</div>
              </div>
            )
          })}
        </div>
      )
    }
  }
})
